import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGenerateOfferDraftMutation } from "../../../services/draftsService";
import { openPdfPreview } from "./openPdfPreview";

export const OfferDraftPreview = (props) => {
    const { drafts, selectedDraft, onDraftChange, offerId, selectedDocumentIds, getRequestDataForGenerateOffer } = props;
    const { t } = useTranslation();

    const { mutate: generatePdf, isPending } = useGenerateOfferDraftMutation({
        onSuccess: (response) => openPdfPreview(response.data),
    });

    const previewDisabled = !selectedDraft || isPending;
    const inputLabelId = "offer-draft-select-label";

    const handlePreview = () => {
        generatePdf({
            draftId: selectedDraft.id,
            requestBody: {...getRequestDataForGenerateOffer(), document_ids: selectedDocumentIds}
            // requestBody: { offer_id: offerId, document_ids: selectedDocumentIds },
        });
    };

    return (
        <Box>
            <FormControl fullWidth>
                <InputLabel id={inputLabelId}>
                    {t("offers.SendOfferTab.selectOfferDraft")}*
                </InputLabel>
                <Select
                    labelId={inputLabelId}
                    value={selectedDraft?.id || ""}
                    label={`${t("offers.SendOfferTab.selectOfferDraft")}*`}
                    onChange={(event) => {
                        const draftId = event.target.value;
                        const draft = drafts.find((d) => d.id === draftId) || null;
                        onDraftChange(draft);
                    }}
                >
                    {drafts.map((draft) => (
                        <MenuItem key={draft.id} value={draft.id}>
                            {draft.name}
                        </MenuItem>
                    ))}
                </Select>
                <LoadingButton
                    onClick={handlePreview}
                    startIcon={<RemoveRedEyeOutlinedIcon />}
                    disabled={previewDisabled}
                    loading={isPending}
                    sx={{
                        "& .MuiCircularProgress-root": {
                            color: "text.primary",
                        },
                    }}
                >
                    {t("offers.SendOfferTab.previewDraft")}
                </LoadingButton>
            </FormControl>
        </Box>
    );
};
